module.exports = __webpack_public_path__ + "static/media/video.f5ee0c04.svg";